import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=18b7de2f"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b7de2f')) {
      api.createRecord('18b7de2f', component.options)
    } else {
      api.reload('18b7de2f', component.options)
    }
    module.hot.accept("./Select.vue?vue&type=template&id=18b7de2f", function () {
      api.rerender('18b7de2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/Select.vue"
export default component.exports